import { env } from "./env";
import { supabase } from "./supabase";

export type AssetOperationAction =
  | "upsert-counterparty"
  | "create-vehicle"
  | "create-property"
  | "create-vehicle-sale"
  | "create-property-lease"
  | "create-vehicle-rental"
  | "create-charge"
  | "activate-agreement"
  | "terminate-agreement"
  | "update-mileage"
  | "add-expense";

function stringValue(value: unknown): string | undefined {
  return typeof value === "string" ? value : undefined;
}

function asError(value: unknown): Error {
  return value instanceof Error
    ? value
    : new Error(stringValue(value) ?? "Operação não disponível.");
}

export async function invokeAssetOperation<T>(
  action: AssetOperationAction,
  tenantSlug: string,
  payload: Record<string, unknown>,
): Promise<T> {
  if (env.useMocks) {
    await new Promise((resolve) => window.setTimeout(resolve, 250));
    return {
      ok: true,
      result: {
        id: crypto.randomUUID(),
        action,
        demo: true,
      },
    } as T;
  }

  const response = await supabase.functions.invoke("asset-operations", {
    body: {
      action,
      tenantSlug,
      idempotencyKey: stringValue(payload.idempotencyKey) ?? crypto.randomUUID(),
      ...payload,
    },
  });

  const error: unknown = response.error;
  if (error) throw asError(error);
  const data: unknown = response.data;
  return data as T;
}

export function currencyToCents(value: string): string {
  const normalized = value
    .trim()
    .replace(/\s/g, "")
    .replace(/^R\$/i, "")
    .replace(/\./g, "")
    .replace(",", ".");

  if (!normalized || !/^\d+(?:\.\d{1,2})?$/.test(normalized)) {
    throw new Error("Valor monetário inválido.");
  }

  const [integer, decimals = ""] = normalized.split(".");
  return (BigInt(integer ?? "0") * 100n + BigInt(decimals.padEnd(2, "0"))).toString();
}
